import { FormBuilder } from '@/components/formBuilder';
import { useEmailField } from '@/components/formBuilder/formFields/useEmailField';
import { Box } from '@chakra-ui/react';
import React, { useRef, useEffect } from 'react';

interface EmailBodyFieldsProps {
  formik: any;
  initialValues?: any;
  containerProps?: any;
  onChange?: (values: any) => void;
  onSurveySelect?: (selectedSurvey: any) => void;
  onSurveyRemove?: (removedSurvey: any) => void;
  selectedSurvey?: any;
}

export const EmailBodyFields: React.FC<EmailBodyFieldsProps> = ({
  formik,
  initialValues,
  containerProps = {},
  onChange,
  onSurveySelect,
  onSurveyRemove,
  selectedSurvey = null,
}) => {
  useEffect(() => {
    // We will set the selected survey in the local storage so that
    // it can be used in the survey select component
    localStorage.setItem(
      'editorSelectedSurvey',
      JSON.stringify(selectedSurvey)
    );
    // for the edit case
    if (selectedSurvey?.label) {
      onSurveySelect?.(selectedSurvey);
    }
  }, [selectedSurvey, selectedSurvey?.label]);

  const emailFormRef = useRef(null);
  const hasCalledInitialOnChange = useRef(false);

  // Trigger onChange with initialValues once the form is mounted
  useEffect(() => {
    if (!hasCalledInitialOnChange.current && emailFormRef.current?.values) {
      hasCalledInitialOnChange.current = true;
      onChange?.(emailFormRef.current.values);
    }
  });

  const emailFields = useEmailField({
    formRef: emailFormRef,
    userEmailType: 'hiringTeam',
    templateData: formik?.values || {},
    onSurveySelect,
    onSurveyRemove,
    // since useEmailField is common across all the email flows,
    // we need to enable survey selection only for the rejection email flow
    enableSurveySelection: true,
  }) as any;

  const emailFormConfig = [
    {
      id: 'emailFormConfig',
      type: 'wrapper',
      fields: emailFields,
      Wrapper: Box,
      wrapperProps: {
        border: '1px solid',
        borderColor: 'border-color',
        borderRadius: 'sm',
      },
    },
  ];

  const handleFormChange = (values: any) => {
    // 'values' comes from FormikOnChangeObserver which reads from Formik context
    // This is already initialized with initialValues, so use it directly
    onChange?.(values);
  };

  return (
    <Box {...containerProps}>
      <FormBuilder
        config={emailFormConfig}
        formRef={emailFormRef}
        initialValues={initialValues}
        isObserveEnabled={true}
        observFunc={handleFormChange}
      />
    </Box>
  );
};
